import { render, staticRenderFns } from "./UserProfileGeneral.vue?vue&type=template&id=1d8d4ab3&scoped=true&"
import script from "./UserProfileGeneral.vue?vue&type=script&lang=js&"
export * from "./UserProfileGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileGeneral.vue?vue&type=style&index=0&id=1d8d4ab3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d4ab3",
  null
  
)

export default component.exports